import React from 'react';
import CalendarView from '../components/Calendar/CalendarView';

const HomePage: React.FC = () => {
    return <CalendarView />;
};

export default HomePage;
